<template>
  <div>
    <BuyReport v-if="isReportAboutMe() || showBuyProcess()" v-bind="buyButtonProps" @buy="buy">
      <template v-slot:caption>
        <template v-if="!user && isLoggedIn">
          <label class="mt-4">{{ $t('report.identityCode') }}</label>
          <ValidationField personId :value="identityCode" @validate="fetchUserIf" v-slot="{ valid, touched }">
            <div class="input-group">
              <input
                name="identityCode"
                type="number"
                class="form-control form-control-lg pr-9"
                v-model="identityCode"
                :maxlength="identityCodeLength"
              >
              <div class="input-group-append">
                <span class="input-group-text icon-search d-none d-md-block" />
              </div>
            </div>
            <div class="user-control has-error" v-if="isCodeFull && touched && (!valid || errorMessage)">
              <span class="icon icon-cancel-circle2" />
              <div>
                <span>{{ errorMessage || defaultErrorMessage }}</span>
              </div>
            </div>
          </ValidationField>
          <div class="user-control" name="userInfo" v-if="hasUser">
            <span class="icon icon-checkmark-circle" />
            <div>
              <span v-if="foundUser.name">{{ $t('report.userName') }}: {{ foundUser.name }}</span>
              <span>{{ $t('report.identityCode') }}: {{ foundUser.personId }}</span>
            </div>
          </div>
          <span class="sidebar-caption">
            {{ $t('report.identityCodeHint') }}
          </span>
        </template>
      </template>
    </BuyReport>
    <RequestConsent
        v-else
        v-bind="requestConsentProps"
        @resetFoundUser="resetFoundUser()">
    </RequestConsent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BuyReport from './BuyReport';
import ValidationField from './ValidationField';
import RequestConsent from './RequestConsent.vue';

export default {
  props: {
    product: Object,
    user: Object,
  },
  components: {
    BuyReport,
    ValidationField,
    RequestConsent,
  },
  data() {
    return {
      id: Date.now(),
      identityCode: '',
      identityCodeLength: Number(import.meta.env.VITE_IDENTITY_CODE_LENGTH),
      foundUser: this.user || {},
      defaultErrorMessage: this.$t('validation.personIdentityCode'),
      errorMessage: '',
      successMessage: '',
      consent: {},
    };
  },
  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('session', ['isLoggedIn']),

    hasUser() {
      return !!this.foundUser.personId;
    },
    canBuy() {
      return this.hasUser && !this.isLoading;
    },
    buyButtonProps() {
      return {
        product: this.product,
        buttonClass: 'mt-9 mb-9',
        disabled: !this.canBuy,
      };
    },
    isCodeFull() {
      return this.identityCode.toString().length === this.identityCodeLength;
    },
    requestConsentProps() {
      return {
        product: this.product,
        consent: this.consent,
        foundUser: this.foundUser,
      };
    },
  },
  watch: {
    identityCode() {
      if (this.foundUser.personId) {
        this.foundUser = {};
      }
    },
    foundUser() {
      if (this.foundUser && this.foundUser.consents) {
        for (const key in this.foundUser.consents) {
          let consent = this.foundUser.consents[key];
          if (consent.productCode === this.product.id) {
            this.consent = consent;
          }
        }
      } else {
        this.consent = {};
      }
    }
  },
  methods: {
    ...mapActions('app', ['findPersonByCode']),

    fetchUserIf(condition) {
      if (!condition) {
        return Promise.resolve();
      }

      this.errorMessage = '';
      return this.findPersonByCode(this.identityCode)
        .then((user) => this.foundUser = user)
        .catch((error) => {
          if (!error.response || error.response.status !== 404) {
            throw error;
          }

          this.errorMessage = this.$t('validation.userNotFound', { code: this.identityCode });
        });
    },

    buy() {
      if (this.product.requiresUserConsent) {
        if (this.isConsentApproved()) {
          this.buyProduct();
        }
      } else {
        this.buyProduct();
      }
    },

    buyProduct() {
      this.$emit('buy', {
        details: this.foundUser,
      });
    },

    showBuyProcess() {
      if (!this.hasUser) {
        return true;
      } else {
        return this.isConsentApproved();
      }
    },

    isReportAboutMe() {
      return this.product.group === 'my';
    },

    isConsentApproved() {
      return this.consent && this.consent.status === 'APPROVED';
    },

    resetFoundUser() {
      this.foundUser = {};
      this.identityCode = false;
    },
  },
};
</script>
